var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { SpellDurationGauge } from './spell-duration-gauge';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            position: 'relative',
            height: 6,
            padding: spacing(0.25),
            flexGrow: 1
        },
        gauge: {
            backgroundColor: palette.background.default,
            position: 'absolute',
            top: 0,
            bottom: 0,
            padding: 1,
            minWidth: 3
        }
    });
});
export var SpellGaugeList = function (_a) {
    var startTime = _a.startTime, duration = _a.duration, spellDurationList = _a.spellDurationList;
    var classes = useStyles();
    var content = spellDurationList.map(function (props) {
        var right = ((props.startTime - startTime) / duration) * 100 + "%";
        var width = (props.duration / duration) * 100 + "%";
        return React.createElement("div", { key: props.startTime, className: classes.gauge, style: { right: right, width: width } },
            React.createElement(SpellDurationGauge, __assign({}, props)));
    });
    return (React.createElement("div", { className: classes.root }, content));
};
